import { Typography } from '@mui/material';
import React from 'react';

import { Checkbox } from '@/shared/components/ui/checkbox/checkbox';
import { TSearchableSelectOptionProps } from '@/shared/components/ui/form/components/searchable-select/components/option/searchable-select-option.types';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';

export const SearchableSelectOption: React.FC<TSearchableSelectOptionProps> = ({
  children,
  disabled,
  selected,
  multiple,
  ...props
}) => {
  if (multiple) {
    return (
      <MenuItem
        disabled={disabled}
        icon={<Checkbox disabled={disabled} checked={selected} />}
        {...props}
      >
        <Typography variant="p8">{children}</Typography>
      </MenuItem>
    );
  }

  return (
    <MenuItem disabled={disabled} selected={selected} {...props}>
      {children}
    </MenuItem>
  );
};
